import React from 'react';
import {
	Dialog,
	DialogContent,
	Button,
	DialogActions,
	useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StyledDialogTitle from './DialogTitle';

const Modal = ({
	open,
	onClose,
	modalTitle = '',
	children,
	maxWidth = 'md',
	alwaysMaxWidth = false,
	fullScreen = false,
	showDividers = false,
	hideBackdrop = false,
	disableBackdropClick = false,
	useActionButtons = false,
	actionButtons = null,
	showCancelButton = false,
	hideCloseButton = false,
	closeButtonName = 'Cancel',
	customTitleElement = null,
	disableEscapeKeyDown = false,
	overrideSx = {},
	overridePaperSx = {},
}) => {
	if (children === null || !children) {
		console.warn(
			'null children in Modal? ',
			children,
			typeof children,
			modalTitle,
		);
	}

	const theme = useTheme();
	const useFullScreen =
		useMediaQuery(theme.breakpoints.down('md')) || fullScreen;

	return (
		<Dialog
			aria-label={modalTitle}
			slotProps={{
				paper: {
					sx: {
						...(Object.entries(overridePaperSx).length && overridePaperSx),
					},
				},
			}}
			open={open}
			onClose={(event, reason) => {
				if (reason === 'backdropClick' && disableBackdropClick) {
					return;
				}
				onClose();
			}}
			fullScreen={useFullScreen}
			maxWidth={maxWidth}
			hideBackdrop={hideBackdrop}
			fullWidth={alwaysMaxWidth}
			disableEscapeKeyDown={disableEscapeKeyDown}
		>
			<StyledDialogTitle
				onClose={onClose}
				hideCloseButton={disableBackdropClick || hideCloseButton}
				customElement={customTitleElement}
			>
				{modalTitle}
			</StyledDialogTitle>
			<DialogContent
				dividers={showDividers}
				sx={{ ...(Object.entries(overrideSx).length && overrideSx) }}
			>
				{/* TOTEST: this de-rendering when not open shouldn't cause any issues but test all Modals anyways */}
				{/* {open && children} */}
				{children}
			</DialogContent>
			{useActionButtons && (
				<DialogActions sx={{ px: 3, py: 2, justifyContent: 'flex-end' }}>
					{showCancelButton && (
						<Button onClick={onClose} color="primary">
							{closeButtonName}
						</Button>
					)}
					{actionButtons}
				</DialogActions>
			)}
		</Dialog>
	);
};

export default Modal;
